export enum GuaranteedOfferType {
    CreditLimit = 'CreditLimit',
    GuaranteedApr = 'GuaranteedApr',
    GuaranteedAprAndCreditLimit = 'GuaranteedAprAndCreditLimit',
    GuaranteedCreditLimit = 'GuaranteedCreditLimit',
    MarketingOffer = 'MarketingOffer',
    PreApprovedAndGuaranteedApr = 'PreApprovedAndGuaranteedApr',
    PreApprovedAndGuaranteedCreditLimit = 'PreApprovedAndGuaranteedCreditLimit',
}
